module.exports = __webpack_public_path__ + "static/microsoft-40774b27222740e1d46ba8320dade273.png";